/** Served agent reference, kept separate from resource registration so its contract is testable. */
export const AGENT_CHEATSHEET = `# Product Brain — Agent Cheatsheet

## Core Tools (Serves 13 default compound tools; 2 more (chain, chain-review) behind PB_MODULES=gitchain — map retired, L29)
| Tool | Purpose | Key params |
|---|---|---|
| \`orient\` | Workspace context, governance, active work packages, session start | \`action\`: start, task, record-activation |
| \`capture\` | Create entry (draft), single or batch | \`collection\`, \`name\`, \`description\`, optional \`data\` / \`items[]\` |
| \`entries\` | List / get / batch / search / update / commit / history / move / verify | \`action\` + \`entryId\` / \`query\` / \`collection\` |
| \`relations\` | Create / batch-create / dismiss / delete / find / suggest links | \`action\` + \`from\`, \`to\`, \`type\` or \`entryId\` |
| \`context\` | Gather related knowledge, last-verified brief | \`action\` + \`entryId\` or \`task\` |
| \`collections\` | List / create / update collections, manage labels | \`action\` |
| \`quality\` | Score an entry, verify the Chain, audit a work package | \`action\`: check, re-evaluate, verify-chain, audit |
| \`session\` | Start / close, wrapup, resume, constellation accept | \`action\`: start, close, status, wrapup-review, wrapup-commit, resume, commit-constellation |
| \`workflows\` | Run workflows, checkpoint, load a skill | \`action\`: list, start, checkpoint, get-run, load-skill |
| \`workspace\` | Check / whoami / status / self-test, usage, governance proposals | \`action\`: check, whoami, status, audit, self-test, usage, proposals-* |
| \`feedback\` | Submit product feedback (any key, no session required); \`list\` reads back your own workspace's feedback (no gate); vendor triage: queue / note / group / status | \`action\`: submit, list, queue, note, group, status |
| \`shape\` | Review / disposition write-shape (single-concern split) advisories | \`action\`: list, show, agree, dismiss |
| \`question\` | Routed questions — create/adopt, own, snooze, decline, answer, force-close | \`action\`: create, adopt, assign, snooze, decline, answer, force-close |

## Collection Prefixes
GLO (glossary), BR (business-rules), PRI (principles), STD (standards),
DEC (decisions), STR (strategy), TEN (tensions), FEAT (features),
BET (bets), INS (insights), ARCH (architecture), TEAM (teams),
ROL (roles), MTRC (tracking-events), ST (semantic-types)

## Valid Relation Types (24)
informs, governs, surfaces_tension_in, defines_term_for, belongs_to,
references, related_to, fills_slot, commits_to, informed_by, depends_on,
conflicts_with, confused_with, replaces, part_of, constrains,
governed_by, alternative_to, has_proposal, requests_promotion_of, resolves,
anchored_to, authority_domain, domain_routed_to

## Lifecycle Status
All entries: \`draft\` | \`active\` | \`deprecated\` | \`archived\`

## Workflow Status (per collection)
- **tensions:** open → processing → decided → closed
- **decisions:** pending → decided
- **bets:** shaped → bet → building → shipped
- **business-rules:** active | conflict | review

## Key Patterns
- **Capture flow:** \`capture\` → \`relations action=suggest\` → \`relations action=batch-create\` → \`entries action=commit\`
- Use \`workflowStatus\` (not \`status\`) for domain workflow state
- \`data\` param is merged (not replaced) — safe for partial updates
`;
